<template>
  <div>
    <div
      v-if="!preContratoGerado"
      class="aviso-pre-geracao"
    >
      <p>Contrato não gerado!</p>
      <p>Para gerar o contrato, salve os dados na primeira aba e volte aqui.</p>
    </div>
    <div v-else>
      <div
        v-if="statusAtual !== null"
        :class="'mb-2 p-2 rounded ' + (statusAtual === 2 ? 'bg-light border-success' : 'aviso-amarelo')"
      >
        <p>Status da assinatura: <strong>{{ getStatusLabel(statusAtual) }}</strong></p>

        <p v-if="statusAtual === 2">
          Contrato já assinado!
          <a
            :href="getUrlConsultaPublica()"
            target="_blank"
            rel="noopener noreferrer"
          >
            Acessar Pagina de Consulta Pública
          </a>
        </p>

        <b-button
          size="sm"
          variant="info"
          @click="showHistoricoModal"
        >
          Ver Histórico
        </b-button>
      </div>

      <p>Selecione a ordem de assinantes e opções de envio.</p>

      <contrato-assinantes
        v-model="assinantes"
        :documento="getActiveDocumento()"
      />

      <hr>

      <div class="text-right mt-3">
        <b-button
          v-if="statusAtual !== 2"
          size="sm"
          variant="primary"
          @click="enviarParaAssinar"
        >
          {{ statusAtual === 1 ? 'Reenviar para assinar' : 'Enviar para assinar' }}
        </b-button>
      </div>
    </div>

    <!-- Modal de Histórico de Assinaturas -->
    <b-modal
      ref="historicoModal"
      title="Histórico de Assinaturas do Contrato"
      size="lg"
      hide-footer
    >
      <div v-if="!getActiveDocumento()">
        <p>Nenhum documento ativo encontrado.</p>
      </div>
      <div v-else>
        <h6>{{ getActiveDocumento().nomeArquivo || 'Documento Ativo' }}</h6>
        <p><strong>Status:</strong> {{ getStatusLabel(getActiveDocumento().status) }}</p>
        <div v-if="!getActiveDocumento().historicos || getActiveDocumento().historicos.length === 0">
          <p>Nenhum histórico de ações encontrado para o documento ativo.</p>
        </div>
        <div v-else>
          <div
            v-for="(h, idx) in getActiveDocumento().historicos"
            :key="idx"
            class="historico-item mb-3 p-3 border rounded"
          >
            <p><strong>Ação:</strong> {{ h.acao }}</p>
            <p><strong>Título:</strong> {{ h.titulo }}</p>
            <p><strong>Usuário:</strong> {{ h.usuario }} <span v-if="h.interno">(Interno)</span></p>
            <p><strong>Descrição:</strong> {{ h.descricao }}</p>
            <p><strong>Data:</strong> {{ formatDataAcao(h.dataAcao) }}</p>
            <p v-if="h.geolocalizacao">
              <strong>Geolocalização:</strong> {{ h.geolocalizacao }}
            </p>
            <p v-if="h.chavePublicaDocumento">
              <strong>Chave Pública:</strong> {{ h.chavePublicaDocumento }}
            </p>
            <p v-if="h.dadosAdicionais">
              <strong>Dados Adicionais:</strong> {{ h.dadosAdicionais }}
            </p>
          </div>
        </div>
      </div>
      <div class="text-right">
        <b-button
          variant="secondary"
          @click="hideHistoricoModal"
        >
          Fechar
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'
import apiPreGeracao from '@/app-modulo/comercial/cadastro-proposta/shared/components/pre-geracao-contrato-proposta/services/api'
import apiDocSign from '@/shared/mixins/docu-sign/docu-sign'
import apiProposta from '@/app-modulo/comercial/cadastro-proposta/shared/services/api'
import ContratoAssinantes from './components/shared/contrato-assinaturas/ContratoAssinantes.vue'

export default {
  name: 'ContratoPropostaTab',
  components: { ContratoAssinantes },
  props: {
    propostaAtual: {
      type: Object,
      default: () => ({}),
    },
    preGeracaoSocios: {
      type: Array,
      default: () => [],
    },
    preContratoGerado: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      assinantes: [],
      documentosAssinatura: [],
      statusAtual: null,
    }
  },
  computed: {
    transformedSocios() {
      return this.preGeracaoSocios.map(socio => ({
        id: socio.id,
        usuarioInternoId: null,
        SocioEmpresaId: socio.id,
        tipoAssinante: 'Signatario',
        nomeAssinante: socio.nome,
        inscricao: socio.inscricao,
        email: socio.email,
        telefone: socio.telefoneContato?.celular || socio.telefoneContato?.telefone || null,
        notificarEmail: !!socio.email,
        notificarWhatsApp: false,
        notificarSMS: false,
        tipoInscricao: socio.tipoInscricao === 'cpf' ? 'CPF' : 'CNPJ',
        statusAssinante: null,
        ordem: null,
      }))
    },
  },
  created() {
    this.loadDocumentosAssinatura()
  },
  methods: {
    loadDocumentosAssinatura() {
      // load existing signers if any
      if (this.preContratoGerado) {
        this.$isLoading(true)
        apiProposta.getDocumentosAssinaturaProposta(this.propostaAtual.id)
          .then(response => {
            this.documentosAssinatura = response.data || []
            if (this.documentosAssinatura.length > 0) {
              const activeDoc = this.getActiveDocumento()

              if (activeDoc) {
                this.statusAtual = activeDoc.status
                this.assinantes = activeDoc.documentoAssinantes.map(assinante => ({
                  id: assinante.id,
                  ordem: assinante.ordem,
                  tipoInscricao: assinante.tipoInscricao,
                  statusAssinante: assinante.statusAssinante,
                  tipoAssinante: assinante.tipoAssinante || 'Signatario',
                  nomeAssinante: assinante.nomeAssinante,
                  inscricao: assinante.inscricao,
                  tokenVerificacao: assinante.tokenVerificacao,
                  email: assinante.email,
                  telefone: null, // não vem na resposta
                  notificarEmail: assinante.notificarEmail,
                  notificarWhatsApp: false,
                  notificarSMS: false,
                }))
              }
            }
          })
          .catch(() => {
            this.$erro('Erro ao carregar os assinantes do contrato. Tente novamente mais tarde.')
          })
          .finally(() => {
            this.$isLoading(false)
          })
      }
    },
    formatDataAcao(dateStr) {
      if (!dateStr) return 'N/A'
      return moment(dateStr).format('DD/MM/YYYY HH:mm:ss')
    },
    getActiveDocumento() {
      if (this.documentosAssinatura.length === 0) return null

      const activeDoc = this.documentosAssinatura
        .filter(doc => doc.status !== 3 && doc.status !== 4)
        .sort((a, b) => new Date(b.dataCadastro) - new Date(a.dataCadastro))[0]

      if (!activeDoc) return null
      return activeDoc
    },
    getStatusLabel(status) {
      const labels = {
        0: 'Pendente',
        1: 'Em Andamento',
        2: 'Assinado',
        3: 'Cancelado',
        4: 'Expirado',
      }
      return labels[status] || 'Desconhecido'
    },
    showHistoricoModal() {
      this.$refs.historicoModal.show()
    },
    hideHistoricoModal() {
      this.$refs.historicoModal.hide()
    },
    /**
     * Detecta o cenário de envio do contrato
     * 1 = Primeiro envio (novo contrato)
     * 2 = Edição de signatários
     */
    detectarCenario() {
      if (this.documentosAssinatura.length === 0) {
        return 1
      }

      const activeDoc = this.getActiveDocumento()

      if (!activeDoc) {
        return 1
      }

      const todosAssinaram = activeDoc.documentoAssinantes.every(
        assinante => assinante.statusAssinante === 2,
      )

      if (todosAssinaram) {
        return 2
      }

      return 2
    },
    /**
     * Verifica se há novos assinantes (sem id = não foram cadastrados no backend)
     */
    temNovoAssinante() {
      return this.assinantes.some(a => a.id === null || a.id === undefined)
    },
    /**
     * Verifica se há assinantes removidos/alterados
     */
    temAlteracaoAssinantes() {
      if (this.documentosAssinatura.length === 0) return false

      const activeDoc = this.getActiveDocumento()
      if (!activeDoc) return false

      if (this.assinantes.length !== activeDoc.documentoAssinantes.length) {
        return true
      }

      return false
    },
    obterContratoSubstituir(propostaId) {
      const contratoLocal = (this.propostaAtual && (this.propostaAtual.contrato || this.propostaAtual.contratoSubstituir)) || ''
      const contratoSanitizado = typeof contratoLocal === 'string' ? contratoLocal.replace(/[\u200B-\u200D\uFEFF]/g, '') : ''
      if (contratoSanitizado && contratoSanitizado.trim().length > 0) {
        return Promise.resolve(contratoSanitizado)
      }

      return apiProposta.getPreGeracaoContrato(propostaId)
        .then(res => {
          const c = res && res.data && (res.data.contratoSubstituir || res.data.contrato || '')
          return (typeof c === 'string' ? c.replace(/[\u200B-\u200D\uFEFF]/g, '') : '')
        })
        .catch(() => contratoSanitizado)
    },

    enviarParaAssinar() {
      if (!this.assinantes || this.assinantes.length === 0) {
        this.$erro('Adicione pelo menos um assinante')
        return
      }

      // garante que o id da proposta existe e não é undefined
      const propostaId = (this.propostaAtual && this.propostaAtual.id) || (this.$route && this.$route.params && (this.$route.params.id || this.$route.params.propostaId))

      if (!propostaId) {
        this.$erro('Não foi possível identificar a proposta para enviar o contrato. Salve a proposta e tente novamente.')
        return
      }

      const cenario = this.detectarCenario()

      // Cenário 1: Primeiro envio
      if (cenario === 1) {
        this.$isLoading(true)
        this.obterContratoSubstituir(propostaId)
          .then(contratoSubstituir => {
            if (!contratoSubstituir || !contratoSubstituir.trim()) {
              throw new Error('CONTRATO_VAZIO')
            }
            return apiProposta.salvarAlteracaoContrato({ contratoSubstituir }, propostaId)
          })
          .then(() => apiPreGeracao.enviarContratoParaAssinatura(propostaId, this.assinantes))
          .then(() => {
            this.$sucesso('Contrato enviado para assinatura com sucesso.')
            this.$emit('contrato-enviado', this.assinantes)
          })
          .catch(err => {
            if (err && err.message === 'CONTRATO_VAZIO') {
              this.$erro('O contrato não pode estar vazio. Verifique o contrato e tente novamente.')
              return
            }
            this.$erro('Erro ao enviar o contrato para assinatura. Tente novamente mais tarde.')
          })
          .finally(() => {
            this.$isLoading(false)
          })
        return
      }

      // Cenário 2: Edição de signatários (contrato já em andamento/assinado)
      if (cenario === 2) {
        // opcional: se não houve alteração de assinantes, nem pergunta
        if (!this.temNovoAssinante() && !this.temAlteracaoAssinantes()) {
          this.$aviso('Não há alterações de assinantes para enviar.')
          return
        }

        this.$bvModal.msgBoxConfirm(
          'Você está editando signatários em um contrato que já está em andamento. Deseja continuar?',
          {
            title: 'Editar Assinantes',
            okVariant: 'info',
            okTitle: 'Sim, editar',
            cancelTitle: 'Cancelar',
          },
        )
          .then(value => {
            if (value) {
              const activeDoc = this.getActiveDocumento()
              if (!activeDoc) {
                this.$erro('Nenhum contrato ativo encontrado para atualização de assinantes.')
                return
              }

              this.$isLoading(true)
              apiDocSign.AtualizarAssinantesContrato(activeDoc.id, this.assinantes)
                .then(() => {
                  this.$sucesso('Assinantes atualizados com sucesso.')
                  this.$emit('contrato-enviado', this.assinantes)
                })
                .catch(() => {
                  this.$erro('Erro ao atualizar os assinantes. Tente novamente mais tarde.')
                })
                .finally(() => {
                  this.$isLoading(false)
                })
            }
          })
      }
    },
    getUrlConsultaPublica() {
      const activeDoc = this.getActiveDocumento()
      if (!activeDoc) return '#'
      const historicoComChave = (activeDoc.historicos || []).find(h => h.chavePublicaDocumento)
      if (!historicoComChave) return '#'

      const chave = historicoComChave.chavePublicaDocumento

      try {
        if (this.$router && typeof this.$router.resolve === 'function') {
          const resolved = this.$router.resolve({
            name: 'portalproposta-consulta',
            params: { publicKey: chave },
          })
          if (resolved && resolved.href) return resolved.href
        }
      } catch (e) {
        // fallback abaixo
      }

      return `${window.location.origin}/assinatura/consulta/${chave}`
    },
  },
}
</script>

<style lang="scss">
.aviso-pre-geracao {
  text-align: left;
  font-size: 15.5px;
  background-color: rgb(231, 231, 231) !important;
  padding: 0.5rem;
  margin-bottom: 1rem;
  color: rgb(255, 0, 0);
  font-weight: bold;
  p {
    margin: 0;
  }
}

.aviso-amarelo {
  text-align: left;
  font-size: 15.5px;
  background-color: lightgoldenrodyellow;
  padding: 0.5rem;
  margin-bottom: 10px;
}

.historico-item {
  background-color: #f8f9fa;
}
</style>
